import { useQuery } from '@tanstack/react-query';
import { attemptGetInviteUsers } from '../../api/UsersApi';

const fetchInviteUsers = async () => {
    return attemptGetInviteUsers().then((res) => res.data);
};

export const useGetInviteUsers = () => {
    return useQuery({ queryKey: ['users'], queryFn: fetchInviteUsers });
};